export const FLIGHTS_BASE_PATH = '/flights'

export const PROD_CFW_ID = '158464265'

export const QA_CFW_ID = '65279135'

export const PROD_NORMAL_ID = '10000000'

export const QA_NORMAL_ID = '10000000'

// WOW pricing dynamic-content endpoint (per UIENG-5276 / UIENG-6192)
export const FETCH_DYNAMIC_CONTENT_PATH = '/flight/v2/fetch-dynamic-content'

// Single Statsig experiment for WOW pricing (SRP + itinerary)
export const WOW_PRICE_CT_DT_EXPERIMENT_KEY = 'wow_price_ct_dt'
/** @deprecated Use WOW_PRICE_CT_DT_EXPERIMENT_KEY */
export const WOW_PRICE_EXPERIMENT_KEY = WOW_PRICE_CT_DT_EXPERIMENT_KEY
/** @deprecated Use WOW_PRICE_CT_DT_EXPERIMENT_KEY */
export const WOW_PRICE_DOM_EXPERIMENT_KEY = WOW_PRICE_CT_DT_EXPERIMENT_KEY

/**
 * Progressive WOW pricing — number of cards fetched per scroll batch after
 * the initial 100. Backend can override via `searchData.configData.progressiveWowSolutionsCount`.
 * Source: flights-pwa UIENG-6303.
 */
export const DEFAULT_PROGRESSIVE_BATCH_SIZE = 10